import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

const StContainer = styled.div<{
  backdropEnabled: boolean
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  ${({ theme, backdropEnabled }) => `
    gap: ${theme.UI.SpacingPx.Space4};
    ${
      backdropEnabled
        ? `
          // background: ${theme.Colors.Background.Light};
          overflow: visible;
          // border-radius: 12px;
          // padding: 12px 16px;
          // margin-left: -16px;
          // margin-right: -16px;
          `
        : null
    }
  `}
`

const StIcon = styled(FontAwesomeIcon)`
  ${({ theme }) => `
    width: 16px;
    height: 16px;
    margin-top: ${theme.UI.SpacingPx.Space1};
    margin-right: ${theme.UI.SpacingPx.Space3};
  `}
`

export { StContainer, StIcon }
